import { styled } from '@mui/system';
import { Paper } from '@mui/material';

export const CardPaper = styled(Paper)(() => ({
  backgroundColor: 'transparent',
}));
